<template>
  <a class="linkButton" :class="linkButtonStyleClass" :href="href" target="_blank" role="button">
    <slot />
  </a>
</template>

<script>
export default {
  name: 'LinkButton',
  props: {
    href: {
      required: true,
      type: String
    },
    color: {
      required: false,
      type: String,
      validator: (value) => {
        return ['white', 'purple'].indexOf(value) !== -1
      },
      default: 'white'
    },
    shape: {
      required: false,
      type: String,
      validator: (value) => {
        return ['border', 'solid'].indexOf(value) !== -1
      },
      default: 'border'
    }
  },
  computed: {
    linkButtonStyleClass () {
      const shapeType = this.shape[0].toUpperCase() + this.shape.slice(1)
      return 'linkButton--' + this.color + shapeType
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/stylesheets/variables';
@import '../../assets/stylesheets/mixins';

.linkButton {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 400px;
  box-sizing: border-box;
  font-weight: bold;
  color: inherit;
  cursor: pointer;
  transition: background-color ease-in 0.2s, border-color ease-in 0.2s;
  @include bpOnlyPc() {
    height: 80px;
    font-size: 18px;
    border: 4px solid;
  }
  @include bpOnlySp() {
    height: 60px;
    font-size: 16px;
    border: 2px solid;
  }
  &--whiteBorder {
    color: $white;
    border-color: $white;
    background-color: $buildNavy;
    &:hover {
      color: $buildNavy;
      background-color: $white;
    }
    &:active {
      background: darken($white, 20%);
      border-color: darken($white, 20%);
    }
  }
  &--purpleBorder {
    color: $purple;
    border-color: $purple;
    &:hover {
      color: $white;
      background-color: $purple;
    }
    &:active {
      background: darken($purple, 20%);
      border-color: darken($purple, 20%);
    }
  }
  &--purpleSolid {
    color: $white;
    border-color: $purple;
    background-color: $purple;
    &:hover {
      color: $purple;
      border-color: $white;
      background-color: $white;
    }
    &:active {
      background: darken($white, 20%);
      border-color: darken($white, 20%);
    }
  }
}
</style>
